import { render, staticRenderFns } from "./all-projects.vue?vue&type=template&id=40e4f279"
import script from "./all-projects.vue?vue&type=script&lang=js"
export * from "./all-projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports